const pricing = [
  {
    id: 1,
    title: 'Standard Plan',
    content: 'perfect for small businesses',
    price: 19.99,
    unit: '/month',
    features: [
      'Pixel Perfect',
      'Premium Paper',
      'Design Work',
      'Extra Thick',
      'Email Support',
    ],
  },
  {
    id: 2,
    title: 'Premium Plan',
    content: 'perfect for big businesses',
    price: 49.99,
    unit: '/month',
    features: [
      'Pixel Perfect',
      'Premium Paper',
      'Design Work',
      'Extra Thick',
      'Priority Support',
    ],
  },
  {
    id: 3,
    title: 'Ultimate Plan',
    content: 'perfect for enterprise',
    price: 99.99,
    unit: '/month',
    features: [
      'Pixel Perfect',
      'Premium Paper',
      'Design Work',
      'Extra Thick',
      'Dedicated Account Manager',
    ],
  },
];

export default pricing;